import React, { type FC, useEffect } from 'react'

import setMenuItem from 'Helpers/setMenuItem'
import { PageHeader } from 'mailup-web-components'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'

const Header: FC = () => {
  const intl = useIntl()
  const navigate = useNavigate()

  useEffect(() => {
    setMenuItem('FiltersCategories')
  }, [])

  const breadcrumbsItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Recipients' }),
      'data-mu-test': 'breadcrumb-item__recipients',
      onClick: Function.prototype,
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.RecipientsFilters' }),
      'data-mu-test': 'breadcrumb-item__filters',
      url: '/filters/list',
      onClick: () => {
        navigate('/filters/list')
      },
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.FiltersCategories' }),
      'data-mu-test': 'breadcrumb-item__list',
      onClick: Function.prototype,
    },
  ]

  const menuItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.FiltersList' }),
      'data-mu-test': 'topmenu-item__filters',
      onClick: () => {
        navigate('/filters/list')
      },
    },
    {
      label: intl.formatMessage({
        id: 'Load.NavMenu.FiltersCategories',
      }),
      'data-mu-test': 'topmenu-item__categories',
      isActive: true,
    },
  ]

  return (
    <PageHeader
      title={intl.formatMessage({ id: 'Load.NavMenu.FiltersCategories' })}
      breadcrumbsItems={breadcrumbsItems}
      menuItems={menuItems}
    />
  )
}

export default Header
